export default __webpack_public_path__ + "static/media/Ballroll_00099.e9132993.png";